// config
import * as http from 'utils/http';
import config from 'config';

const getPriceSuggestion = async ({ id, priceSuggestionDTO }) => {
  return http.post(`${config.API_URL}price-negotiation/tickets/${id}/prices/`, priceSuggestionDTO);
};

export default getPriceSuggestion;
